import { queryOptions } from "@tanstack/react-query";
import { OfficeId, PayerId } from "../../shared/schema/schema";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => {
  return {
    // With an office the server narrows the Sandata duty codes to the ones of that office's state.
    sandataMappings: (officeId?: OfficeId | null) =>
      queryOptions({
        queryKey: ["evv-duty-code-mapping", "sandata", officeId ?? null],
        queryFn: () =>
          api.get("./sandata_poc_item_mappings", {
            query: officeId === null || officeId === undefined ? {} : { officeId },
          }),
      }),

    hhaxPayers: () =>
      queryOptions({
        queryKey: ["evv-duty-code-mapping", "hhax-payers"],
        queryFn: () => api.get("./hhax_poc_payers", {}),
      }),

    hhaxItems: (payerId: PayerId) =>
      queryOptions({
        queryKey: ["evv-duty-code-mapping", "hhax-items", payerId],
        queryFn: () => api.get("./hhax_poc/:payerId", { path: { payerId } }),
      }),

    // The plan of care settings carry the Medflyt items plus their current HHAeXchange mapping
    // per payer. Note the path uses /coordinator/, not the usual agency_members prefix.
    planOfCareSettings: () =>
      queryOptions({
        queryKey: ["evv-duty-code-mapping", "plan-of-care-settings"],
        queryFn: () =>
          api.get("/agencies/:agencyId/coordinator/:agencyMemberId/plan_of_care_settings", {}),
      }),
  };
});
